export default __webpack_public_path__ + "3dd32b5a75cbd120c6a9d118c1a4728d.glb";